import { Action,createReducer,on } from '@ngrx/store';
import { Agency } from '../../shared/models/agency.model';
import * as AgencyActions from './agencys.actions';



export interface State {
  agencys: Agency[];
  editAgency: Agency;
  editAgencyIndex: number;
  loading: boolean;
  error: null | string;
}

const initialState: State = {
  agencys: [],
  editAgency: null,
  editAgencyIndex: -1,
  loading: false,
  error: null
};

export const agencyListReducer = createReducer(
  initialState,
  on(AgencyActions.loadAgencys, state => (
    console.log('LOAD AGENCYS FROM ACTIONS'),
    { ...state, loading: true }
  )),
  on(AgencyActions.getAgencys, state => ({ ...state, loading: false })),
)
